"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let OPEN_OVERLAY = '';
let CLOSE_OVERLAY = '';
let SET_NEW_FOLDER_NAME = '';
let SET_NEW_FOLDER_DESCRIPTION = '';
let EDIT_CUSTOM_META = '';
let SAVE_PROPERTIES_REQUEST = '';
let SAVE_PROPERTIES_SUCCESS = '';
let SAVE_PROPERTIES_FAILURE = '';
let SAVE_NEW_FOLDER_REQUEST = '';
let SAVE_NEW_FOLDER_SUCCESS = '';
let SAVE_NEW_FOLDER_FAILURE = '';
let DELETE_REQUEST = '';
let DELETE_SUCCESS = '';
let DELETE_FAILURE = '';
let VALIDATION_FAILURE = '';
let GET_TTL_REQUEST = '';
let GET_TTL_SUCCESS = '';
let GET_TTL_FAILURE = '';
let SET_TTL_REQUEST = '';
let SET_TTL_SUCCESS = '';
let SET_TTL_FAILURE = '';
let CLEAR = '';
function default_1(namespace) {
    OPEN_OVERLAY = `@sok/modules/files/crud/${namespace}/OPEN_OVERLAY`;
    CLOSE_OVERLAY = `@sok/modules/files/crud/${namespace}/CLOSE_OVERLAY`;
    SET_NEW_FOLDER_NAME = `@sok/modules/files/crud/${namespace}/SET_NEW_FOLDER_NAME`;
    SET_NEW_FOLDER_DESCRIPTION = `@sok/modules/files/crud/${namespace}/SET_NEW_FOLDER_DESCRIPTION`;
    EDIT_CUSTOM_META = `@sok/modules/files/crud/${namespace}/EDIT_CUSTOM_META`;
    SAVE_PROPERTIES_REQUEST = `@sok/modules/files/crud/${namespace}/SAVE_PROPERTIES_REQUEST`;
    SAVE_PROPERTIES_SUCCESS = `@sok/modules/files/crud/${namespace}/SAVE_PROPERTIES_SUCCESS`;
    SAVE_PROPERTIES_FAILURE = `@sok/modules/files/crud/${namespace}/SAVE_PROPERTIES_FAILURE`;
    SAVE_NEW_FOLDER_REQUEST = `@sok/modules/files/crud/${namespace}/SAVE_NEW_FOLDER_REQUEST`;
    SAVE_NEW_FOLDER_SUCCESS = `@sok/modules/files/crud/${namespace}/SAVE_NEW_FOLDER_SUCCESS`;
    SAVE_NEW_FOLDER_FAILURE = `@sok/modules/files/crud/${namespace}/SAVE_NEW_FOLDER_FAILURE`;
    DELETE_REQUEST = `@sok/modules/files/crud/${namespace}/DELETE_REQUEST`;
    DELETE_FAILURE = `@sok/modules/files/crud/${namespace}/DELETE_FAILURE`;
    DELETE_SUCCESS = `@sok/modules/files/crud/${namespace}/DELETE_SUCCESS`;
    VALIDATION_FAILURE = `@sok/modules/files/crud/${namespace}/VALIDATION_FAILURE`;
    GET_TTL_REQUEST = `@sok/modules/files/crud/${namespace}/GET_TTL_REQUEST`;
    GET_TTL_FAILURE = `@sok/modules/files/crud/${namespace}/GET_TTL_FAILURE`;
    GET_TTL_SUCCESS = `@sok/modules/files/crud/${namespace}/GET_TTL_SUCCESS`;
    SET_TTL_REQUEST = `@sok/modules/files/crud/${namespace}/SET_TTL_REQUEST`;
    SET_TTL_FAILURE = `@sok/modules/files/crud/${namespace}/SET_TTL_FAILURE`;
    SET_TTL_SUCCESS = `@sok/modules/files/crud/${namespace}/SET_TTL_SUCCESS`;
    CLEAR = `@sok/modules/files/crud/${namespace}/CLEAR`;
    return {
        OPEN_OVERLAY,
        CLOSE_OVERLAY,
        SET_NEW_FOLDER_NAME,
        SET_NEW_FOLDER_DESCRIPTION,
        EDIT_CUSTOM_META,
        SAVE_PROPERTIES_REQUEST,
        SAVE_PROPERTIES_SUCCESS,
        SAVE_PROPERTIES_FAILURE,
        SAVE_NEW_FOLDER_REQUEST,
        SAVE_NEW_FOLDER_SUCCESS,
        SAVE_NEW_FOLDER_FAILURE,
        DELETE_REQUEST,
        DELETE_FAILURE,
        DELETE_SUCCESS,
        VALIDATION_FAILURE,
        GET_TTL_REQUEST,
        GET_TTL_FAILURE,
        GET_TTL_SUCCESS,
        SET_TTL_REQUEST,
        SET_TTL_FAILURE,
        SET_TTL_SUCCESS,
        CLEAR
    };
}
exports.default = default_1;
//# sourceMappingURL=actionTypes.js.map